import LogoTitle from "assets/img/dock_title.png";

export default function PageLoader() {
  return (
    <div className="page page-center">
      <div className="container container-slim py-4" style={{ width: 250 }}>
        <div className="text-center">
          <div className="flex justify-center mb-3">
            <div className="self-center w-28">
              <img className="object-contain" src={LogoTitle} />
            </div>
          </div>
          <div className="text-secondary mb-3">Загрузка данных</div>
          <div className="progress progress-sm">
            <div className="progress-bar progress-bar-indeterminate"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
